export default "__VITE_ASSET__09a21f48__"